export enum VaultMemberAssignStatusEnum {
    Waiting = 'waiting',
    InProgress = 'in-progress',
    Done = 'done',
    Error = 'error'
}
